import classNames from 'classnames'

interface PricingBenefitInfoProps {
  title: string | React.ReactNode
  subTitle: string
  icon?: React.ReactNode
  borderTop?: boolean
  borderBottom?: boolean
}

const PricingBenefitInfo = ({
  title,
  subTitle,
  icon = null,
  borderTop = true,
  borderBottom = false,
}: PricingBenefitInfoProps) => {
  return (
    <div
      className={classNames('py-12 flex items-center gap-8 border-t', {
        'border-b': borderBottom,
        'border-t': borderTop,
      })}
    >
      {icon}
      <div className="flex gap-4 sm:flex-row flex-col items-start sm:items-center">
        <span className="text-gray-700 Body2-14Md">{title}</span>
        <span className="ml-4 text-gray-500 Caption-12Md">{subTitle}</span>
      </div>
    </div>
  )
}

export default PricingBenefitInfo
